export default "__VITE_ASSET__BXNf4THR__"